import React from "react";
import publicRoutes from "./publicRoutes";

// Importar rutas de cada feature (ahora con nombres explícitos)
import authRoutes from "@features/auth/auth.routes";
import { dashboardRoutes } from "@features/role-dashboards";
import inventoryRoutes from "@features/inventory/inventory.routes";
import maintenanceRoutes from "@features/maintenance/maintenance.routes";
import reportsRoutes from "@features/reports/reports.routes";
import toolsRoutes from "@features/tools/tools.routes";
import landingRoutes from "@features/landing/landing.routes";
import formatsRoutes from "@features/formats/formats.routes";
import certificationsRoutes from "@features/certifications/certifications.routes";
import planAnualRoutes from "@features/plan-anual/plan-anual.routes";
import developerToolsRoutes from "@features/developer-tools/developer-tools.routes";
import monitoringRoutes from "@features/monitoring/monitoring.routes";
import emergencyContactsRoutes from "@features/emergency-contacts/emergency-contacts.routes";
import pendientesRoutes from "@features/pendientes/pendientes.routes";
import calendarRoutes from "@features/calendar/calendar.routes";
import equipmentRoutes from "@features/equipment/equipment.routes";
import catalogosRoutes from "@features/catalogos/catalogos.routes";
import risersRoutes from "@features/risers/risers.routes";
import aiAgentRoutes from "@features/ai-agent/ai-agent.routes";
import securityRoutes from "@features/security/security.routes";
import sessionsRoutes from "@features/sessions/sessions.routes";
import personalTodosRoutes from "@features/personalTodos/personalTodos.routes";
import usersRoutes from "@features/users/users.routes";

/**
 * Combina todas las rutas de la aplicación
 *
 * Estructura:
 * 1. Rutas públicas (login, signup, etc.)
 * 2. Rutas por feature (organizadas por dominio)
 * 3. Ruta 404 (incluida en publicRoutes al final)
 *
 * Cada feature es responsable de definir sus propias rutas
 * en su archivo routes.jsx, manteniendo la cohesión del FSD
 */
export const allRoutes = [
  // Rutas públicas (sin autenticación)
  ...publicRoutes.slice(0, -1), // Todas menos el 404

  // Rutas protegidas por feature
  ...authRoutes, // /profile, /change-password, /firma
  ...dashboardRoutes, // /homeadmin, /homeinspector, /homesupervisor, etc.
  ...inventoryRoutes, // /inventory, /scanner, etc.
  ...maintenanceRoutes, // /mantenimiento
  ...reportsRoutes, // /reportes
  ...toolsRoutes, // /herramientas, /tool-scanner
  ...landingRoutes, // /homepage
  ...formatsRoutes, // /formatos
  ...certificationsRoutes, // /inspector/certificaciones, /supervisor/certificaciones
  ...planAnualRoutes, // /admin/plan-anual, /supervisor/plan-anual 
  ...developerToolsRoutes, // /homedeveloper
  ...monitoringRoutes, // /monitor
  ...emergencyContactsRoutes, // /alarmcontrol
  ...pendientesRoutes, // /pendientes
  ...calendarRoutes, // /calendario-social
  ...equipmentRoutes, // /inspector/equipment
  ...catalogosRoutes, // /catalogos (Admin, Developer)
  ...risersRoutes, // /planos-interactivos
  ...aiAgentRoutes, // /ai-agent
  ...securityRoutes, // /security-dashboard
  ...sessionsRoutes, // /sessions-management
  ...personalTodosRoutes, // /personal-todos
  ...usersRoutes, // /developer/users

  // Ruta 404 al final
  ...publicRoutes.slice(-1),
];

export default allRoutes;
